<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№ п/п" v-bind="$form.input('number')" />
        <n-input title="Номер линии" v-bind="$form.input('lineNum')" />
        <n-datepicker title="Дата предыдущей проверки, номера линии однотипных сварных стыков выполненных сварщиком после нее" v-bind="$form.input('lastCheckDate')" inline />
        <n-datepicker title="Дата сварки контролируемого сварного соединения" v-bind="$form.input('weldingDate')" inline />
        <n-input title="Номер сварного соединения по чертежам (исполнительным чертежам)" v-bind="$form.input('weldingNum')" />
        <n-input title="Температура, условия проведения сварки, ГРС" v-bind="$form.input('temp')" />
        <n-input title="Труба (ДнхS), мм, марка стали (композиция марок сталей)" v-bind="$form.input('pipe')" />
        <n-input title="Сварочные материалы: Электрод" v-bind="$form.input('electrod')" />
        <n-input title="Сварочные материалы: Проволока" v-bind="$form.input('provoloka')" />
        <n-input title="Сварочные материалы: флюс" v-bind="$form.input('flus')" />
        <n-input title="Сварочные материалы: Защитный газ" v-bind="$form.input('guardingGas')" />
        <n-input title="Дата термической обработки, регистрационный номер в журнале" v-bind="$form.input('termDate')" />
        <n-input title="Дата и номер протокола замератвердости" v-bind="$form.input('protocolNum')" />
        <n-input title="Результат контроля качества сварки: Радиографический или ультразвуковой контроль, номер заключения" v-bind="$form.input('result1')" />
        <n-input title="Результат контроля качества сварки: Механический свойства сварного соединения образца, вырезанного из контрольного стыка,номер протокола, дата" v-bind="$form.input('result2')" />
        <n-input title="Результат контроля качества сварки: Металография, номер протокола, дата" v-bind="$form.input('result3')" />
        <n-input title="Результат контроля качества сварки: ферритная фаза, номер протокола, дата" v-bind="$form.input('result4')" />
        <n-input title="Результат контроля качества сварки: Склонность к МКК, номер протокола, дата" v-bind="$form.input('result5')" />
        <n-input title="Заключение о качестве проконтролированных сварных соединений и допуске сварщика к сварке однотипных сварных соединений" v-bind="$form.input('remark')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
